var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu_item",on:{"click":function($event){return _vm.movePage()}}},[_c('div',{staticClass:"image-container"},[_c('img',{class:{ coin: _vm.label === 'Coin' },attrs:{"src":`${_vm.image}?v=1`}}),(_vm.label === 'Cart' && _vm.cartItemCount > 0)?_c('div',{staticClass:"cart-badge"}):_vm._e()]),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }